export default "__VITE_ASSET__D3q0O7nU__"